import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useState, useEffect, useRef } from "react";
import { uploadFile } from "../../services/uploadService";
import InputMask from "react-input-mask";
import { handleUnauthorized } from "../../../src/utils/apiHelper";
import { useNavigate } from "react-router-dom";
import SuccessAlert from "./../child/Alert/SuccessAlert";
import DengerAlert from "./../child/Alert/DengerAlert";
import Loader from "./../child/Loder";

const AddSubAdminPageNew = () => {
  const [imagePreview, setImagePreview] = useState(
    "assets/images/user-grid/user-grid-img13.png"
  );
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [Name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [imagechange, SetImagechnage] = useState(0);
  const [selectedPermissions, setSelectedPermissions] = useState({});
  const [Modulename, setModuleData] = useState([]);
  const [newPassword, setNewPassword] = useState("");
  const [successMessage, setSuccessMessage] = useState(""); // Manage Success Message
  const [errorMessage, setErrorMessage] = useState(""); // Manage Success Message
  const [role, setRole] = useState("support_admin"); // Default role

  const navigate = useNavigate();
  const togglePasswordVisibility = () => setPasswordVisible((prev) => !prev);

  const handleCheckboxChange = (id, permission) => {
    setSelectedPermissions((prevPermissions) => {
      const updatedPermissions = { ...prevPermissions };

      // Ensure module exists in updatedPermissions
      if (!updatedPermissions[id]) {
        updatedPermissions[id] = {
          selected: false,
          add: false,
          edit: false,
          view: false,
          delete: false,
        };
      }

      if (permission === "selected") {
        // Toggle all permissions if module checkbox is clicked
        const newCheckedState = !updatedPermissions[id].selected;
        updatedPermissions[id] = {
          selected: newCheckedState,
          add: newCheckedState,
          edit: newCheckedState,
          view: newCheckedState,
          delete: newCheckedState,
        };
      } else {  
        // Toggle individual permission
        updatedPermissions[id][permission] =
          !updatedPermissions[id][permission];

        updatedPermissions[id].selected =
          updatedPermissions[id].add ||
          updatedPermissions[id].edit ||
          updatedPermissions[id].view ||
          updatedPermissions[id].delete;
      }

      return updatedPermissions;
    });
  };

  useEffect(() => {
    const fetchModuleData = async () => {
      const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/moduleList`;
      try {
        setLoading(true);
        const authToken = localStorage.getItem("authToken");
        const response = await fetch(API_ENDPOINT, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        });

        if (!response.ok) {
          throw new Error("Failed to fetch modules");
        }

        const data = await response.json();

        setModuleData(data.modules || []);
      } catch (err) {
        setErrorMessage(err.message);
        setTimeout(() => {
          setErrorMessage("");
        }, 3000);
      } finally {
        setLoading(false);
      }
    };

    fetchModuleData();
  }, []);
  const permissions = Object.entries(selectedPermissions).map(
    ([moduleId, perms]) => ({
      module: moduleId,
      moduleName:
        Modulename.find((item) => item._id === moduleId)?.title || "Unknown",
      add: perms?.add || false,
      edit: perms?.edit || false,
      view: perms?.view || false,
      delete: perms?.delete || false,
    })
  );

  const readURL = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = async (e) => {
        try {
          const uploadedProfilePicture = await uploadFile(file);

          setImagePreview(uploadedProfilePicture);
          SetImagechnage(1);
          // imgchnage = 1;
        } catch (error) {
          console.error("Error uploading image:", error);
          setErrorMessage("Failed to upload image");
          setTimeout(() => setErrorMessage(""), 3000);
        }
      };
      reader.readAsDataURL(file);
    }
  };
  const allowedMimeTypes = ["image/png", "image/jpeg", "image/jpg"];
  const validateInputs = () => {
    const newErrors = {};
    if (!Name) newErrors.Name = "Full name is required";
    if (!phone) newErrors.phone = "Phone is required";
    if (!email) newErrors.email = "Email is required";
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (Name) {
      if (!/^[A-Za-z\s]+$/.test(Name)) {
        newErrors.Name = "Full name must contain only alphabets";
      }
    }
    if (email) {
      if (!emailPattern.test(email)) {
        newErrors.email = "Enter a valid email address";
      }
    }
    const numericPhone = phone.replace(/\D/g, "");
    if (phone) {
      if (numericPhone.length !== 11) {
        newErrors.phone = "Enter valid phone number";
      }
    }

    // if (imagechange == 0) {
    //   newErrors.profilePicture = "Profile image is required.";
    // }
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    if (!newPassword) {
      newErrors.newPassword = "New password is required";
    } else if (!passwordRegex.test(newPassword)) {
      newErrors.newPassword =
        "Password must be at least 8 characters long, include an uppercase letter, a lowercase letter, and a number";
    }
    if (imagechange === 1) {
      if (imagePreview) {
        try {
          const url = new URL(imagePreview);
          const pathname = url.pathname;
          const type = pathname.split(".").pop().toLowerCase();

          if (!allowedMimeTypes.includes(`image/${type}`)) {
            newErrors.profilePicture = "Only png and jpg files are allowed.";
          }
        } catch (error) {
          console.error("Invalid URL:", error);
        }
      }
    }
    if (Object.keys(newErrors).length != 0) {
      if (
        document
          .getElementById("pills-change-passwork")
          ?.classList.contains("show")
      ) {
        setErrorMessage(
          "Please fill  all information from Personal profile section"
        );
        setTimeout(() => {
          setErrorMessage("");
        }, 3000);
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const personalinfohandleSubmit = async (event) => {
    event.preventDefault();
    if (!validateInputs()) return;
    document
      .getElementById("pills-change-passwork-tab")
      ?.classList.add("active");
    document
      .getElementById("pills-change-passwork-tab")
      ?.setAttribute("aria-selected", "true");
    document
      .getElementById("pills-edit-profile-tab")
      ?.classList.remove("active");
    document
      .getElementById("pills-edit-profile-tab")
      ?.setAttribute("aria-selected", "false");
    document.getElementById("pills-change-passwork")?.classList.add("active");
    document.getElementById("pills-change-passwork")?.classList.add("show");
    document.getElementById("pills-edit-profile")?.classList.remove("active");
    document.getElementById("pills-edit-profile")?.classList.add("hide");

    if (role === "super_admin") {
      handleSubmit(event);
    }
  };
  const handleSubmit = async (event) => {
    if (role === "support_admin" && permissions.length === 0) {
      setErrorMessage("Please grant permission to select any module access.");
      setTimeout(() => {
        setErrorMessage("");
      }, 3000);
      return;
    }
    event.preventDefault();
    if (!validateInputs()) return;
    setLoading(true);

    let uploadedProfilePicture = imagePreview;

    const API_ENDPOINT = role === "support_admin"
      ? `${process.env.REACT_APP_BASE_URL}/admin/supportAdminAdd`
      : `${process.env.REACT_APP_BASE_URL}/admin/signUp`;
    const authToken = localStorage.getItem("authToken");

    let phoneNumber;
    let countryCode;
    const pattern = /\(\d{3}\)/;
    if (pattern.test(phone)) {
      countryCode = phone.match(/^\+?\d+/)?.[0] || "";
    } else {
      countryCode = phone.match(/^\+?\d+/)?.[0] || "";
      const formattedNumber = phone.startsWith("+")
        ? phone.substring(countryCode.length)
        : phone;
      phoneNumber = formattedNumber.replace(
        /(\d{3})(\d{3})(\d{4})/,
        "($1) $2-$3"
      );
    }

    phoneNumber = phone.replace(/\D/g, "");

    if (phoneNumber.startsWith("+")) {
      let countryCodeMatch = phone.match(/^\+\d+/)?.[0];
      if (countryCodeMatch) {
        phoneNumber = phoneNumber.replace(
          countryCodeMatch.replace(/\D/g, ""),
          ""
        ); // Remove country code
      }
    } else {
      countryCode = phoneNumber.charAt(0); // First digit as country code
      phoneNumber = phoneNumber.substring(1); // Remove first digit from phone number
    }
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    try {
      const response = await fetch(API_ENDPOINT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify({
          name: Name,
          email: email,
          password: newPassword,
          profilePicture: uploadedProfilePicture,
          dialCode: "+" + countryCode,
          phone: phoneNumber,
          timeZone: timeZone,
          role: role,
          permissions: role === "support_admin" ? permissions : [],
        }),
      });

      if (response.status === 401) {
        handleUnauthorized(navigate);
        return;
      }

      const data = await response.json();

      if (response.ok) {
        setSuccessMessage("Sub admin has been added successfully.");
        setLoading(false);
        setTimeout(() => {
          setSuccessMessage("");
          navigate("/subadmin");
        }, 1000);
      } else {
        setErrorMessage(data.message);
        setTimeout(() => {
          setErrorMessage("");
        }, 3000);
        return;
      }
    } catch (error) {
      setErrorMessage(error.message);
      setTimeout(() => {
        setErrorMessage("");
      }, 3000);
    } finally {
      // setLoading(false);
    }
  };
  if (loading) return <Loader />;
  return (
    <div className="row gy-4">
      <div className="col-lg-4">
        {successMessage && (
          <SuccessAlert
            message={successMessage}
            onClose={() => setSuccessMessage("")}
          />
        )}
        {errorMessage && (
          <DengerAlert
            message={errorMessage}
            onClose={() => setErrorMessage("")}
          />
        )}
      </div>
      <div className="col-md-12">
        <div className="card h-100">
          <div className="card-body p-24">
            <ul
              className="nav border-gradient-tab nav-pills mb-20 d-inline-flex"
              id="pills-tab"
              role="tablist"
            >
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link d-flex align-items-center px-24 active"
                  id="pills-edit-profile-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-edit-profile"
                  type="button"
                  role="tab"
                  aria-controls="pills-edit-profile"
                  aria-selected="true"
                >
                  Personal Information
                </button>
              </li>
              <li className="nav-item" role="presentation">
                {role === "support_admin" && (
                  <button
                    className="nav-link d-flex align-items-center px-24"
                    id="pills-change-passwork-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-change-passwork"
                    type="button"
                    role="tab"
                    aria-controls="pills-change-passwork"
                    aria-selected="false"
                    tabIndex={-1}
                  >
                    Module Access
                  </button>
                )}
              </li>
            </ul>
            <div className="tab-content" id="pills-tabContent">
              <div
                className="tab-pane fade show active"
                id="pills-edit-profile"
                role="tabpanel"
                aria-labelledby="pills-edit-profile-tab"
                tabIndex={0}
              >
                <h6 className="text-md text-primary-light mb-16">
                  Profile Image
                </h6>
                <form action="#" onSubmit={personalinfohandleSubmit}>
                  {/* Upload Image Start */}
                  <div className="mb-24 mt-16">
                    <div className="avatar-upload">
                      <div className="avatar-edit position-absolute bottom-0 end-0 me-24 mt-16 z-1 cursor-pointer">
                        <input
                          type="file"
                          id="imageUpload"
                          accept=".png, .jpg, .jpeg"
                          hidden
                          onChange={(e) => {
                            readURL(e);
                            setErrors((prev) => ({
                              ...prev,
                              profilePicture: "",
                            }));
                          }}
                        />
                        <label
                          htmlFor="imageUpload"
                          className="w-32-px h-32-px d-flex justify-content-center align-items-center bg-primary-50 text-primary-600 border border-primary-600 bg-hover-primary-100 text-lg rounded-circle"
                        >
                          <Icon
                            icon="solar:camera-outline"
                            className="icon"
                          ></Icon>
                        </label>
                      </div>
                      <div className="avatar-preview">
                        <div
                          id="imagePreview"
                          style={{
                            backgroundImage: `url(${imagePreview})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                          }}
                        />
                      </div>
                    </div>
                    {errors.profilePicture && (
                      <p className="text-danger mt-1">
                        {errors.profilePicture}
                      </p>
                    )}
                  </div>
                  {/* Upload Image End */}

                  <div className="row">
                    <div className="col-sm-6">
                      <div className="mb-20">
                        <label
                          htmlFor="name"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Full Name
                          <span className="text-danger-600">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control radius-8"
                          id="name"
                          placeholder="Enter Full Name"
                          value={Name}
                          onChange={(e) => {
                            setName(e.target.value);
                            setErrors((prev) => ({ ...prev, Name: "" }));
                          }}
                          onInput={(e) => {
                            e.target.value = e.target.value
                              .replace(/\s{2,}/g, " ") // Replace multiple spaces with a single space
                              .trimStart(); // Prevent leading spaces
                          }}
                          maxLength="64"
                          invalid={!!errors.Name}
                        />
                        {errors.Name && (
                          <p className="text-danger mt-1">{errors.Name}</p>
                        )}
                      </div>
                    </div>

                    <div className="col-sm-6">
                      <div className="mb-20">
                        <label
                          htmlFor="number"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Phone<span className="text-danger-600">*</span>
                        </label>
                        <InputMask
                          mask="+9 (999) 999 9999"
                          value={phone}
                          onChange={(e) => {
                            setPhone(e.target.value);
                            setErrors((prev) => ({ ...prev, phone: "" }));
                          }}
                          invalid={!!errors.phone}
                        >
                          {(inputProps) => (
                            <input
                              {...inputProps}
                              type="tel"
                              placeholder="Phone"
                              className="form-control radius-8"
                            />
                          )}
                        </InputMask>

                        {errors.phone && (
                          <p className="text-danger mt-1">{errors.phone}</p>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="mb-20">
                        <label
                          htmlFor="role"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Role<span className="text-danger-600">*</span>
                        </label>
                        <select
                          className="form-control radius-8 form-select"
                          id="role"
                          value={role}
                          onChange={(e) => setRole(e.target.value)}
                        >
                          <option value="support_admin">Support Admin</option>
                          <option value="super_admin">Admin</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="mb-20">
                        <label
                          htmlFor="email"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Email
                          <span className="text-danger-600">*</span>
                        </label>
                        <input
                          type="email"
                          className="form-control radius-8"
                          id="email"
                          maxLength="64"
                          placeholder="Enter Email"
                          value={email}
                          onChange={(e) => {
                            setEmail(e.target.value);
                            setErrors((prev) => ({ ...prev, email: "" }));
                          }}
                          invalid={!!errors.email}
                        />
                        {errors.email && (
                          <p className="text-danger mt-1">{errors.email}</p>
                        )}
                      </div>
                    </div>

                    <div className="col-sm-6">
                      <label
                        htmlFor="your-password"
                        className="form-label fw-semibold text-primary-light text-sm mb-8"
                      >
                        Password <span className="text-danger-600">*</span>
                      </label>
                      <div className="position-relative">
                        <input
                          type={passwordVisible ? "text" : "password"}
                          className="form-control"
                          maxLength="20"
                          id="new-password"
                          placeholder="Enter New Password"
                          value={newPassword}
                          onChange={(e) => {
                            setNewPassword(e.target.value);
                            setErrors((prev) => ({ ...prev, newPassword: "" }));
                          }}
                          onInput={(e) => {
                            e.target.value = e.target.value
                              .replace(/\s{2,}/g, " ") // Replace multiple spaces with a single space
                              .trimStart(); // Prevent leading spaces
                          }}
                          invalid={!!errors.newPassword}
                        />
                        <span
                          className={`toggle-password ${passwordVisible ? "ri-eye-off-line" : "ri-eye-line"
                            } cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light`}
                          onClick={togglePasswordVisibility}
                        ></span>
                        {errors.newPassword && (
                          <p className="text-danger mt-1">
                            {errors.newPassword}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                  <div
                    className="d-flex align-items-center justify-content-center gap-3"
                    style={{
                      float: "inline-end",
                      marginTop: "10px !important",
                    }}
                  >
                    <button
                      type="submit"
                      className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                    >
                      {role === "super_admin" ? (loading ? "Saving..." : "Save") : "Next"}
                    </button>
                  </div>
                </form>
              </div>
              <div
                className="tab-pane fade"
                id="pills-change-passwork"
                role="tabpanel"
                aria-labelledby="pills-change-passwork-tab"
                tabIndex="0"
              >
                <form action="#" onSubmit={handleSubmit}>
                  <div className="">
                    <div className="table-responsive">
                      <table className="table basic-border-table mb-0">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Module Name</th>
                            <th>Add</th>
                            <th>Edit</th>
                            <th>View</th>
                            <th>Delete</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Modulename.length > 0 ? (
                            Modulename.filter(
                              (item) =>
                                item.permissions &&
                                (item.permissions.add ||
                                  item.permissions.edit ||
                                  item.permissions.view ||
                                  item.permissions.delete)
                            ).map((item) => (
                              <tr key={item._id}>
                                <td>
                                  <input
                                    className="form-check-input radius-4 border input-form-dark"
                                    type="checkbox"
                                    id={`module_${item._id}`}
                                    checked={
                                      selectedPermissions[item._id]?.selected ||
                                      false
                                    }
                                    onChange={() =>
                                      handleCheckboxChange(item._id, "selected")
                                    }
                                  />
                                </td>
                                <td>
                                  {item.title === "Space Type"
                                    ? "Storage Type"
                                    : item.title === "chatpayment"
                                      ? "Chat Payment"
                                      : item.title === "transaction-promotion"
                                        ? "Promotion Payment"
                                        : item.title === "booking"
                                          ? "Help & Support Ticket"
                                          : item.title === "supportticket"
                                            ? "Booking"
                                            : item.title}
                                </td>

                                <td>
                                  {item.permissions.add ? (
                                    <input
                                      className="form-check-input radius-4 border input-form-dark"
                                      type="checkbox"
                                      id={`add_${item._id}`}
                                      checked={
                                        selectedPermissions[item._id]?.add ||
                                        false
                                      }
                                      onChange={() =>
                                        handleCheckboxChange(item._id, "add")
                                      }
                                    />
                                  ) : (
                                    "-"
                                  )}
                                </td>
                                <td>
                                  {item.permissions.edit ? (
                                    <input
                                      className="form-check-input radius-4 border input-form-dark"
                                      type="checkbox"
                                      id={`edit_${item._id}`}
                                      checked={
                                        selectedPermissions[item._id]?.edit ||
                                        false
                                      }
                                      onChange={() =>
                                        handleCheckboxChange(item._id, "edit")
                                      }
                                    />
                                  ) : (
                                    "-"
                                  )}
                                </td>
                                <td>
                                  {item.permissions.view ? (
                                    <input
                                      className="form-check-input radius-4 border input-form-dark"
                                      type="checkbox"
                                      id={`view_${item._id}`}
                                      checked={
                                        selectedPermissions[item._id]?.view ||
                                        false
                                      }
                                      onChange={() =>
                                        handleCheckboxChange(item._id, "view")
                                      }
                                    />
                                  ) : (
                                    "-"
                                  )}
                                </td>
                                <td>
                                  {item.permissions.delete ? (
                                    <input
                                      className="form-check-input radius-4 border input-form-dark"
                                      type="checkbox"
                                      id={`delete_${item._id}`}
                                      checked={
                                        selectedPermissions[item._id]?.delete ||
                                        false
                                      }
                                      onChange={() =>
                                        handleCheckboxChange(item._id, "delete")
                                      }
                                    />
                                  ) : (
                                    "-"
                                  )}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="6" className="text-center">
                                No Modules Found
                              </td>
                            </tr>
                          )}
                          {errors.permissions && (
                            <div className="invalid-feedback">
                              {errors.permissions}
                            </div>
                          )}
                        </tbody>
                      </table>
                    </div>

                    <button
                      type="submit"
                      className="btn btn-primary border border-primary text-md px-5 py-3 rounded-lg mt-10"
                      disabled={loading}
                      style={{
                        float: "inline-end",
                        marginTop: "10px !important",
                      }}
                    >
                      {loading ? "Saving..." : "Save"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddSubAdminPageNew;
